import { ActionWidget, ActionWidgetProps, RuntimeAction, SPI, Widget, http } from '@kunlun/dependencies';
import Comp from './BindActivityItemTags.vue';

interface CmTagRecord {
  id: string;
  name: string;
}

interface ActivityItemTagRelRecord {
  activityItemId?: number | string;
  activityCode?: string;
  itemTplId?: number | string;
  tagId?: number | string;
  tagName?: string;
}

interface ActivityItemRecord {
  id?: number | string;
  activityCode?: string;
  itemTplId?: number | string;
  tagNames?: string;
  tagDisplayText?: string;
  tagRelList?: ActivityItemTagRelRecord[];
}

@SPI.ClassFactory(
  ActionWidget.Token({
    model: 'deli.aries.settlement.DeliAriesCmActivityItem',
    name: 'uiViewfc5828e730914ec1be8389e7a6f91c70'
  })
)
export class BindActivityItemTagsAction extends ActionWidget {
  public initialize(props: ActionWidgetProps<RuntimeAction>) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  @Widget.Method()
  public async queryTagList() {
    const gql = `
      query {
        deliAriesPlatformCmTagQuery {
          queryPage(
            page: { currentPage: 1, size: 9999 }
            queryWrapper: { rsql: "(1==1)", queryData: {} }
          ) {
            content {
              id
              name
            }
          }
        }
      }
    `;
    const result = await http.query(this.model.moduleName, gql);
    return (result?.data?.deliAriesPlatformCmTagQuery?.queryPage?.content || []) as CmTagRecord[];
  }

  @Widget.Method()
  public getSelectedRows() {
    return (this.activeRecords || []) as ActivityItemRecord[];
  }

  @Widget.Method()
  public applyTagsToSelectedRows(tags: CmTagRecord[]) {
    const selectedRows = (this.activeRecords || []) as ActivityItemRecord[];
    if (!selectedRows.length) {
      return;
    }

    const tagNames = tags.map((item) => item.name).join(',');
    const rowIdSet = new Set(selectedRows.map((item) => item.id));
    const nextDataSource = ((this.dataSource || []) as ActivityItemRecord[]).map((item) => {
      if (!rowIdSet.has(item.id)) {
        return item;
      }
      const tagRelList = tags.map<ActivityItemTagRelRecord>((tag) => ({
        activityItemId: item.id,
        activityCode: item.activityCode,
        itemTplId: item.itemTplId,
        tagId: tag.id,
        tagName: tag.name
      }));

      item.tagNames = tagNames || undefined;
      item.tagDisplayText = tagNames || undefined;
      item.tagRelList = tagRelList;
      return item;
    });

    this.reloadDataSource(nextDataSource as any);
    this.refreshCallChaining?.syncCall(true);
  }
}
